import { useEffect, useState } from "react";
import store from "../../stores/store";
import { useSelector } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import SelectAttributesDropdown from "../controls/selectAttributesDropdrown";
import {
  createNotification,
  getGeometryTypeFromLayer,
  key,
  trans,
} from "../../lib/utils";
import { SketchPicker } from "react-color";
import reactCSS from "reactcss";
import {
  buildSLD,
  buildSLDFile,
  buildSLDStyle,
  getLayerById,
  setLayerParams,
  setLayerSLD,
  setLayerStyle,
  setSLD,
} from "../map/mapUtils";
import { filterFeatureRecordFromAttribute } from "../../lib/featureUtils";
import { Style } from "ol/style.js";

function SLDEditorPanel() {
  const groups = useSelector((state) => store.getState().sldEditor.groups);
  const sldTitle = useSelector((state) => store.getState().sldEditor.sldTitle);
  const sldId = useSelector((state) => store.getState().sldEditor.sldId);
  const sldEditorActiveTab = useSelector(
    (state) => store.getState().sldEditor.sldEditorActiveTab
  );
  const selectedLayer = useSelector(
    (state) => store.getState().sldEditor.layer
  );
  const sldEditors = useSelector(
    (state) => store.getState().sldEditor.sldEditors
  );

  const sources = useSelector((state) => store.getState().sources);
  const layers = useSelector((state) => store.getState().layers);

  const [sldEditorCSS, setSLDEditorCSS] = useState({
    displayColorPicker: false,
    color: {
      r: "241",
      g: "112",
      b: "19",
      a: "1",
    },
  });

  useEffect(() => {
    window["recaclulatePerfectScrollbarHeight"]();
  }, []);

  const styles = reactCSS({
    default: {
      swatch: {
        padding: "5px",
        background: "#fff",
        borderRadius: "1px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
        display: "inline-block",
        cursor: "pointer",
        width: "100%",
      },
      popover: {
        position: "absolute",
        zIndex: "2",
      },
      cover: {
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px",
      },
    },
  });

  const saveSLD = (apply) => {
    if (groups.length > 0) {
      store.dispatch({
        type: "sldEditor/editors/add",
        payload: {
          id: selectedLayer,
          sldId: sldId,
          title: sldTitle,
          groups: [...groups],
        },
      });

      if (apply) {
        setSLD(layers[selectedLayer], sldId, sldEditors[selectedLayer]);
        createNotification({
          type: "success",
          message: trans("SLD saved and applied"),
        });
      } else {
        createNotification({
          type: "success",
          message: trans("SLD saved"),
        });
      }
    } else {
      createNotification({
        type: "danger",
        message: trans("Wrong SLD configuration!"),
      });
    }
    // let sldBody = buildSLDFile(groups, layers[selectedLayer]);

    // setLayerSLD(layers[selectedLayer], sldBody);
  };

  const isDark = (color) => {
    if (!color?.r) {
      return false;
    }
    return 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b <= 120;
  };

  const sldGeometryConfiguration = (group, groupIndex) => {
    return (
      <>
        {group[0]["geometryType"] !== "line" ? (
          <>
            <div className="mt-2">
              <label>
                {group[0]["geometryType"] === "point"
                  ? trans("Point Symbol style")
                  : trans("Fill")}
              </label>
            </div>
            {group[0]["geometryType"] === "point" ? (
              <div className="mt-2">
                <select
                  className="form-select form-select-sm form-control-sm form-control me-2"
                  value={group[0]["geometryType"]}
                  onChange={(e) => {
                    store.dispatch({
                      type: "sldEditor/group/rule/update",
                      payload: {
                        groupIndex: groupIndex,
                        property: "pointsymbol",
                        value: e.target.value,
                      },
                    });
                  }}
                >
                  <option value="">{trans("Select point symbol")}</option>
                  <option value="square">{trans("Square")}</option>
                  <option value="circle">{trans("Circle")}</option>
                  <option value="triangle">{trans("Triangle")}</option>
                  <option value="star">{trans("Star")}</option>
                  <option value="x-square">{trans("X Square")}</option>
                </select>
              </div>
            ) : (
              ""
            )}

            {group[0]["geometryType"] === "polygon" ? (
              <div className="mt-2">
                <select
                  className="form-select form-select-sm form-control-sm form-control me-2"
                  value={group[0]["polygonFill"]}
                  onChange={(e) => {
                    store.dispatch({
                      type: "sldEditor/group/rule/update",
                      payload: {
                        groupIndex: groupIndex,
                        property: "polygonFill",
                        value: e.target.value,
                      },
                    });
                  }}
                >
                  <option value="">{trans("Select fill")}</option>
                  <option value="fill">{trans("Fill color")}</option>
                  <option value="shape://horline">
                    {trans("Horizontal lines")}
                  </option>
                  <option value="shape://vertline">
                    {trans("Vertical lines")}
                  </option>
                  <option value="shape://slash">{trans("Slash lines")}</option>
                  <option value="shape://backslash">
                    {trans("Back slash lines")}
                  </option>
                  <option value="shape://dot">{trans("Dots")}</option>
                  <option value="shape://plus">{trans("Plus")}</option>
                  <option value="shape://times">{trans("X")}</option>
                  <option value="shape://oarrow">{trans("Open arrow")}</option>
                  <option value="shape://carrow">
                    {trans("Closed arrow")}
                  </option>
                </select>
              </div>
            ) : (
              ""
            )}

            <div className="mt-2">
              <div>
                <div
                  style={styles.swatch}
                  onClick={() => {
                    store.dispatch({
                      type: "sldEditor/group/rule/update",
                      payload: {
                        groupIndex: groupIndex,
                        property: "displayColorPicker",
                        value: group[0]["displayColorPicker"] ? false : true,
                      },
                    });
                  }}
                >
                  <div
                    className={"form-control text-center ".concat(
                      isDark(group[0]["fillColor"]?.rgb) ? "text-white" : ""
                    )}
                    style={{
                      borderRadius: "2px",
                      width: "100%",
                      background: `rgba(${group[0]["fillColor"]?.rgb?.r}, ${group[0]["fillColor"]?.rgb?.g}, ${group[0]["fillColor"]?.rgb?.b}, ${group[0]["fillColor"]?.rgb?.a})`,
                    }}
                  >
                    {group[0]["fillColor"]?.hex
                      ? group[0]["fillColor"]?.hex
                      : trans("Select fill color")}
                  </div>
                </div>
                {group[0]["displayColorPicker"] ? (
                  <div style={styles.popover}>
                    <div
                      style={styles.cover}
                      onClick={() => {
                        store.dispatch({
                          type: "sldEditor/group/rule/update",
                          payload: {
                            groupIndex: groupIndex,
                            property: "displayColorPicker",
                            value: false,
                          },
                        });
                      }}
                    />

                    <SketchPicker
                      color={group[0]["fillColor"]}
                      onChange={(color) => {
                        store.dispatch({
                          type: "sldEditor/group/rule/update",
                          payload: {
                            groupIndex: groupIndex,
                            property: "fillColor",
                            value: { rgb: color.rgb, hex: color.hex },
                          },
                        });
                      }}
                    />
                  </div>
                ) : null}
              </div>
            </div>
            {group[0]["geometryType"] === "point" ? (
              <div className="mt-2">
                <select
                  className="form-select form-select-sm form-control-sm form-control me-2"
                  value={group[0]["pointSize"]}
                  onChange={(e) => {
                    store.dispatch({
                      type: "sldEditor/group/rule/update",
                      payload: {
                        groupIndex: groupIndex,
                        property: "pointSize",
                        value: e.target.value,
                      },
                    });
                  }}
                >
                  <option value="">{trans("Select size")}</option>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14, 15, 18, 20].map(
                    (el) => {
                      return <option value={el}>{el}</option>;
                    }
                  )}
                </select>
              </div>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )}
        <div className="mt-2">
          <label>{trans("Border Style")}</label>
        </div>
        <div className="mt-2">
          <select
            className="form-select form-select-sm form-control-sm form-control me-2"
            value={group[0]["borderStyle"]}
            onChange={(e) => {
              store.dispatch({
                type: "sldEditor/group/rule/update",
                payload: {
                  groupIndex: groupIndex,
                  property: "borderStyle",
                  value: e.target.value,
                },
              });
            }}
          >
            <option value="">{trans("Select border style")}</option>
            <option value="solid">{trans("Solid")}</option>
            <option value="5 5">{trans("Dashes")}</option>
            <option value="1 4">{trans("Dots")}</option>
          </select>
        </div>
        <div className="mt-2">
          <div>
            <div
              style={styles.swatch}
              onClick={() => {
                store.dispatch({
                  type: "sldEditor/group/rule/update",
                  payload: {
                    groupIndex: groupIndex,
                    property: "displayBorderColorPicker",
                    value: group[0]["displayBorderColorPicker"] ? false : true,
                  },
                });
              }}
            >
              <div
                className={"form-control text-center ".concat(
                  isDark(group[0]["borderColor"]?.rgb) ? "text-white" : ""
                )}
                style={{
                  borderRadius: "2px",
                  width: "100%",
                  background: `rgba(${group[0]["borderColor"]?.rgb?.r}, ${group[0]["borderColor"]?.rgb?.g}, ${group[0]["borderColor"]?.rgb?.b}, ${group[0]["borderColor"]?.rgb?.a})`,
                }}
              >
                {group[0]["borderColor"]?.hex
                  ? group[0]["borderColor"]?.hex
                  : "Select border color"}
              </div>
            </div>
            {group[0]["displayBorderColorPicker"] ? (
              <div style={styles.popover}>
                <div
                  style={styles.cover}
                  onClick={() => {
                    store.dispatch({
                      type: "sldEditor/group/rule/update",
                      payload: {
                        groupIndex: groupIndex,
                        property: "displayBorderColorPicker",
                        value: false,
                      },
                    });
                  }}
                />

                <SketchPicker
                  color={group[0]["borderColor"]}
                  onChange={(color) => {
                    store.dispatch({
                      type: "sldEditor/group/rule/update",
                      payload: {
                        groupIndex: groupIndex,
                        property: "borderColor",
                        value: { rgb: color.rgb, hex: color.hex },
                      },
                    });
                  }}
                />
              </div>
            ) : null}
          </div>
        </div>
        <div className="mt-2">
          <select
            className="form-select form-select-sm form-control-sm form-control me-2"
            value={group[0]["borderSize"]}
            onChange={(e) => {
              store.dispatch({
                type: "sldEditor/group/rule/update",
                payload: {
                  groupIndex: groupIndex,
                  property: "borderSize",
                  value: e.target.value,
                },
              });
            }}
          >
            <option value="">{trans("Select border size")}</option>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14, 15, 18, 20].map((el) => {
              return <option value={el}>{el}</option>;
            })}
          </select>
        </div>
        <div className="mt-2">
          <label>{trans("Label")}</label>
        </div>
        <div className="mt-2">
          <SelectAttributesDropdown
            attributes={layers[selectedLayer].attributes}
            value={group[0]["labelAttribute"]}
            onChange={(e) => {
              store.dispatch({
                type: "sldEditor/group/rule/update",
                payload: {
                  groupIndex: groupIndex,
                  property: "labelAttribute",
                  value: e.target.value,
                },
              });
            }}
          ></SelectAttributesDropdown>
        </div>
        <div className="mt-2">
          <select
            className="form-select form-select-sm form-control-sm form-control me-2"
            value={group[0]["labelAttributeFontFamily"]}
            onChange={(e) => {
              store.dispatch({
                type: "sldEditor/group/rule/update",
                payload: {
                  groupIndex: groupIndex,
                  property: "labelAttributeFontFamily",
                  value: e.target.value,
                },
              });
            }}
          >
            <option value="">{trans("Select font family")}</option>
            {[
              "Arial",
              "Courier New",
              "Serif",
              "Sans Serif",
              "Tahoma",
              "Times New Roman",
              "Verdana",
            ].map((el) => {
              return <option value={el}>{el}</option>;
            })}
          </select>
        </div>
        <div className="mt-2">
          <select
            className="form-select form-select-sm form-control-sm form-control me-2"
            value={group[0]["labelAttributeFontSize"]}
            onChange={(e) => {
              store.dispatch({
                type: "sldEditor/group/rule/update",
                payload: {
                  groupIndex: groupIndex,
                  property: "labelAttributeFontSize",
                  value: e.target.value,
                },
              });
            }}
          >
            <option value="">{trans("Select font size")}</option>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14, 15, 18, 20].map((el) => {
              return <option value={el}>{el}</option>;
            })}
          </select>
        </div>
        <div className="mt-2">
          <div>
            <div
              style={styles.swatch}
              onClick={() => {
                store.dispatch({
                  type: "sldEditor/group/rule/update",
                  payload: {
                    groupIndex: groupIndex,
                    property: "displayLabelFontColorPicker",
                    value: group[0]["displayLabelFontColorPicker"]
                      ? false
                      : true,
                  },
                });
              }}
            >
              <div
                className={"form-control text-center ".concat(
                  isDark(group[0]["labelFontColor"]?.rgb) ? "text-white" : ""
                )}
                style={{
                  borderRadius: "2px",
                  width: "100%",
                  background: `rgba(${group[0]["labelFontColor"]?.rgb?.r}, ${group[0]["labelFontColor"]?.rgb?.g}, ${group[0]["labelFontColor"]?.rgb?.b}, ${group[0]["labelFontColor"]?.rgb?.a})`,
                }}
              >
                {group[0]["labelFontColor"]?.hex
                  ? group[0]["labelFontColor"]?.hex
                  : trans("Select label font color")}
              </div>
            </div>
            {group[0]["displayLabelFontColorPicker"] ? (
              <div style={styles.popover}>
                <div
                  style={styles.cover}
                  onClick={() => {
                    store.dispatch({
                      type: "sldEditor/group/rule/update",
                      payload: {
                        groupIndex: groupIndex,
                        property: "displayLabelFontColorPicker",
                        value: false,
                      },
                    });
                  }}
                />

                <SketchPicker
                  color={group[0]["labelFontColor"]}
                  onChange={(color) => {
                    store.dispatch({
                      type: "sldEditor/group/rule/update",
                      payload: {
                        groupIndex: groupIndex,
                        property: "labelFontColor",
                        value: { rgb: color.rgb, hex: color.hex },
                      },
                    });
                  }}
                />
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      <div className="m-3 ms-2">
        <select
          className="form-select form-select-sm "
          value={selectedLayer}
          onChange={(e) => {
            store.dispatch({
              type: "sldEditor/layer/update",
              payload: { layer: e.target.value, sldId: key() },
            });
          }}
        >
          <option value="">{trans("Select a layer")}</option>
          {Object.keys(layers)?.map((el) => {
            let layer = layers[el];

            return <option value={layer.id}>{layer.title}</option>;
          })}
        </select>
      </div>
      {selectedLayer ? (
        <div className="m-3 ms-2">
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder={trans("Set SLD title")}
            value={sldTitle}
            onChange={(e) => {
              store.dispatch({
                type: "sldEditor/title/update",
                payload: e.target.value,
              });
            }}
          ></input>
        </div>
      ) : (
        ""
      )}
      <div className="me-3 ms-2">
        <PerfectScrollbar style={{ height: "45px" }}>
          <ul className="nav nav-tabs navbar-expand small">
            {groups.map((group, groupIndex) => {
              return (
                <li className="nav-item " role="button">
                  <span
                    className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                      sldEditorActiveTab === "sldEditor".concat(groupIndex)
                        ? "active"
                        : ""
                    )}
                    onClick={() => {
                      store.dispatch({
                        type: "sldEditor/sldEditorActiveTab",
                        payload: "sldEditor".concat(groupIndex),
                      });
                    }}
                  >
                    <span className="color-black">
                      {"SLD rule ".concat(groupIndex + 1)}
                    </span>
                    <i
                      className="fas fa-times ms-2 results-close-icon"
                      onClick={() => {
                        window["primaryModal"].setState({
                          show: true,
                          size: "default",
                          title: trans("Delete confirmation"),
                          body: (
                            <div className="p-2">
                              {trans("Are you sure you want to remove")}{" "}
                              <strong>
                                '{trans("SLD rule").concat(" ", groupIndex + 1)}
                                '
                              </strong>{" "}
                              {trans("tab")}?
                            </div>
                          ),
                          footer: [
                            <button
                              className="btn btn-sm btn-link"
                              onClick={(e) => {
                                window["primaryModal"].setState({
                                  show: false,
                                });
                              }}
                            >
                              {trans("Cancel")}
                            </button>,
                            <button
                              className="btn btn-sm btn-danger text-white"
                              onClick={(e) => {
                                store.dispatch({
                                  type: "sldEditor/groups/delete",
                                  payload: groupIndex,
                                });
                                window["primaryModal"].setState({
                                  show: false,
                                });
                              }}
                            >
                              {trans("Delete")}
                            </button>,
                          ],
                        });
                      }}
                    ></i>
                  </span>
                </li>
              );
            })}
          </ul>
        </PerfectScrollbar>
      </div>
      <PerfectScrollbar className="p-2 pe-3 mb-2 scrollbar-recaclulate">
        <div className="tab-content ">
          {groups.map((group, groupIndex) => {
            return (
              <div
                className={"tab-pane fade  ".concat(
                  sldEditorActiveTab === "sldEditor".concat(groupIndex)
                    ? "show active"
                    : ""
                )}
                role="tabpanel"
                aria-labelledby={"sldEditor".concat(groupIndex)}
              >
                <div
                  className="card mb-3 small"
                  key={"sldEditorTab".concat(groupIndex)}
                >
                  {/* <div className="card-header p-1">
                    <div className="d-flex">
                      <div className="mt-auto mb-auto me-2 w-100 ps-2 ">
                        <strong>{"SLD rule ".concat(groupIndex + 1)}</strong>
                      </div>
                      <div className="mt-auto mb-auto">
                        <i
                          className="fas fa-trash-alt me-2"
                          role="button"
                          onClick={() => {
                            store.dispatch({
                              type: "sldEditor/groups/delete",
                              payload: groupIndex,
                            });
                          }}
                        ></i>
                      </div>
                    </div>
                  </div> */}
                  <div className="card-body p-2">
                    <div
                      className="card  mb-3 "
                      key={"group".concat("-sld-", groupIndex)}
                    >
                      <div className="card-header p-1 ps-2 pe-2">
                        <div className="d-flex">
                          <div className="w-100">
                            {trans("SLD Configuration")}
                          </div>
                        </div>
                      </div>
                      <div className="card-body  ">
                        <div>
                          <div className="mt-2">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder={trans("Set rule title")}
                              value={group[0]["ruleTitle"]}
                              onChange={(e) => {
                                store.dispatch({
                                  type: "sldEditor/group/rule/update",
                                  payload: {
                                    groupIndex: groupIndex,
                                    property: "ruleTitle",
                                    value: e.target.value,
                                  },
                                });
                              }}
                            ></input>
                          </div>

                          {/* <div className="mt-2">
                            <select
                              className="form-select form-select-sm form-control-sm form-control me-2"
                              value={group[0]["geometryType"]}
                              onChange={(e) => {
                                store.dispatch({
                                  type: "sldEditor/group/rule/update",
                                  payload: {
                                    groupIndex: groupIndex,
                                    property: "geometryType",
                                    value: e.target.value,
                                  },
                                });
                              }}
                            >
                              <option value="">Select geometry type</option>
                              <option value="point">Point</option>
                              <option value="line">Line</option>
                              <option value="polygon">Polygon</option>
                            </select>
                          </div> */}
                          {sldGeometryConfiguration(group, groupIndex)}
                        </div>
                      </div>
                    </div>

                    {group?.map((criteria, criteriaIndex) => {
                      return criteria.type ? (
                        <div
                          className="card  mb-3 "
                          key={"criteria".concat(
                            criteriaIndex,
                            "group",
                            groupIndex
                          )}
                        >
                          <div className="card-header p-1 ps-2 pe-2">
                            <div className="d-flex">
                              <div className="w-100">
                                {criteria.type === "spatial"
                                  ? trans("Spatial criteria")
                                  : trans("Attribute criteria")}
                              </div>
                              <div className="mt-auto mb-auto">
                                <i
                                  className="fas fa-trash-alt me-2"
                                  role="button"
                                  onClick={() => {
                                    store.dispatch({
                                      type: "sldEditor/criteria/delete",
                                      payload: {
                                        groupIndex: groupIndex,
                                        criteriaIndex: criteriaIndex,
                                      },
                                    });
                                  }}
                                ></i>
                              </div>
                            </div>
                          </div>
                          <div className="card-body  ">
                            <div>
                              <div className="mt-2">
                                <SelectAttributesDropdown
                                  key={key()}
                                  value={criteria["attribute"]}
                                  attributes={layers[selectedLayer]?.attributes}
                                  onChange={(e) => {
                                    store.dispatch({
                                      type: "sldEditor/criteria/update",
                                      payload: {
                                        groupIndex: groupIndex,
                                        criteriaIndex: criteriaIndex,
                                        property: "attribute",
                                        value: e.target.value,
                                      },
                                    });
                                  }}
                                ></SelectAttributesDropdown>
                              </div>
                              <div className="mt-2 d-flex">
                                <select
                                  style={{ width: "10rem" }}
                                  className="form-select form-select-sm form-control-sm form-control me-2"
                                  value={criteria["attributeOperator"]}
                                  onChange={(e) => {
                                    store.dispatch({
                                      type: "sldEditor/criteria/update",
                                      payload: {
                                        groupIndex: groupIndex,
                                        criteriaIndex: criteriaIndex,
                                        property: "attributeOperator",
                                        value: e.target.value,
                                      },
                                    });
                                  }}
                                >
                                  <option value="=">=</option>
                                  <option value="like">Like</option>
                                  <option value=">=">&gt;=</option>
                                  <option value=">">&gt;</option>
                                  <option value="<=">&lt;=</option>
                                  <option value="<">&lt;</option>
                                </select>
                                <input
                                  type="text"
                                  className="form-control form-control-sm "
                                  value={criteria["attributeValue"]}
                                  placeholder={trans("Type value...")}
                                  onChange={(e) => {
                                    store.dispatch({
                                      type: "sldEditor/criteria/update",
                                      payload: {
                                        groupIndex: groupIndex,
                                        criteriaIndex: criteriaIndex,
                                        property: "attributeValue",
                                        value: e.target.value,
                                      },
                                    });
                                  }}
                                ></input>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null;
                    })}
                    {group.length === 1 ? (
                      <div className="p-2 small">
                        {trans(
                          "Add attribute filter for your SLD rule by clicking the 'Add attribute criteria' button"
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="card-footer p-1">
                    {selectedLayer ? (
                      <button
                        className="btn  btn-link btn-sm small"
                        onClick={() => {
                          store.dispatch({
                            type: "sldEditor/criteria/add",
                            payload: {
                              groupIndex: groupIndex,
                              criteria: {
                                type: "attributes",
                              },
                            },
                          });
                        }}
                      >
                        <span className="small">
                          <i className="fas fa-plus me-2 small"></i>
                          {trans("Add attribute criteria")}
                        </span>
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {selectedLayer ? (
          <div className="p-0 pe-3 text-end">
            <button
              className="btn btn-secondary btn-sm me-2"
              onClick={() => {
                setTimeout(window["recaclulatePerfectScrollbarHeight"], 0);
                store.dispatch({
                  type: "sldEditor/add",
                  payload: [
                    {
                      operator: "AND",
                      geometryType: getGeometryTypeFromLayer(
                        layers[selectedLayer]?.geometryType
                      ),
                    },
                  ],
                });
              }}
            >
              <span className="text-white">
                <i className="fas fa-plus me-2"></i>
                {trans("Add SLD rule")}
              </span>
            </button>
            {groups.length > 0 ? (
              <>
                <button
                  className="btn btn-secondary btn-sm me-2"
                  onClick={() => {
                    saveSLD();
                  }}
                >
                  <span className="text-white">
                    <i className="fas fa-filter me-2 "></i>
                    {trans("Save")}
                  </span>
                </button>
                <button
                  className="btn btn-secondary btn-sm "
                  onClick={() => {
                    saveSLD(true);
                  }}
                >
                  <span className="text-white">
                    <i className="fas fa-filter me-2 "></i>
                    {trans("Save and apply")}
                  </span>
                </button>
              </>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </PerfectScrollbar>
    </div>
  );
}

export default SLDEditorPanel;
